<template>
    <v-switch
      v-model="value"
      :label="titulo"
      class="sgp-toggle"
      @change="mudarStatusToogle"
      v-bind="$attrs"
      v-on="$listeners"
      :disabled="readOnly"
    >
  </v-switch>
  <!-- <div class="mdn-ToggleGroup">
    <span
      for="cb1"
      class="mdn-Heading mdn-Heading--xxs mx-2 my-2 cursor-pointer"
      @click="checked = !checked;"
      v-if="labelEsquerda"
    >
      {{ titulo }}
    </span>
    
    <div class="mdn-Toggle">
      <div class="mdn-Toggle-list" @click="checked = !checked;">
        <input
          id="cb1"
          class="mdn-Toggle-item mdn-Toggle-item-primary"
          type="checkbox"
          aria-label="My toggle"
          :name="name"
          v-model="value"
        />
        <span class="mdn-Toggle-button" for="cb1" aria-label="My togle"></span>
      </div>
    </div>

    <span
      for="cb1"
      class="mdn-Heading mdn-Heading--xxs mx-2 my-2 cursor-pointer"
      @click="checked = !checked; mudarStatusToogle"
      v-if="!labelEsquerda"
    >
      {{ titulo }}
    </span>
  </div> -->
</template>

<script>
export default {
  name: 'SGPFormToggleComponent',

  props: {
    selecianado: {
      type: Boolean,
      required: false,
      default: false
    },

    name: {
      type: String,
      required: true
    },

    titulo: {
      type: String,
      required: true
    },

    value: {
      required: true,
      default: false
    },

    labelEsquerda: {
      type: Boolean,
      required: false,
      default: false
    },

    readOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return  {
      checked: this.selecianado || false
    }
  },
  
  methods: {
    mudarStatusToogle () {
      this.$emit('input', this.value ||  '');
    },

  },

  mounted () {
    if (this.value) {
      this.checked = this.value;
    }
    
    if(this.selecianado) {
      this.value = this.selecianado
    }
  },

  watch: {
    // checked () {
    //   this.$emit('input', this.checked ||  '');
    // },
    // value() {
    //   this.checked = this.value;      
    // }
  }
}
</script>

<style lang="scss" scoped>
.sgp-toggle {    
  .theme--light.v-messages {
    display: none !important;
    content: "TESTANDO";
  }
}

</style>